import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import React, { FC, useEffect, useMemo, useRef, useState } from "react"
import { Form, Modal } from 'react-bootstrap'
import CurrencyInput from 'react-currency-input-field'
import { useHistory } from "react-router"
import { useRecoilValue } from "recoil"
import { deleteInventory, getFlow, getInventoryInPharmacy, getPharmacyInfoLocal, searchEsProduct, updatePharmacyInventory } from "../../api"
import { getProductStats } from '../../api'
import { FLOW } from '../../config'
import { useAccount } from '../../hooks'
import usePharmacy from "../../hooks/pharmacy"
import { IDongGoi, InventoryModel, InventoryModelWithProductStat, PharmacyDetailModel, ProductModel, ProductStat } from "../../models"
import { accountDataState } from "../../recoil/account"
import { formatPrice, useAsync, useQuery } from "../../utils"
import { Button, Header, RollbarErrorBoundary } from "../shared"
import Loading from "../shared/Loading"
import { getProductPriceTrack, createProductPriceTrack, getProductDropshipingTrackByAdmin, getProductDropshipingTrack, createProductDropshippingTrackByAdmin, createProductDropshippingTrack, updateProductDropshippingTrack, updateProductDropshippingTrackByAdmin, getDropshippingPharmacy, getDropshippingPharmacyByAdmin } from "../../api"
import { isAdmin } from "../../api/account"
import distributorApi, { ProductDistributor } from "../../api/distributor"
import ProductHistory from './LogProduct'


interface IFormValue {
    dong_goi: IDongGoi,
    errors: any,
    values: {
        mPrice?: number;
        mOriginalPrice?: number;
        mStockAmount?: number;
        mInStock: boolean;
    },
    handleSubmit: Function,
    isSubmitting: boolean,
}

interface ProductProps {
    productId: string;
    isModal: boolean;
    handleUpdateSuccess: (invItems: any[]) => void;
    handleCancelUpdate: () => void;
    handleDeleteProduct: (productId: string) => void;
}

export const FormProductPage: FC = () => {
    const query = useQuery()
    const history = useHistory()
    const { clearFlowForApp } = useAccount()

    const productId: string = query.get('productId') || ''

    const handleUpdateSuccess = (invItems: any[]) => {
        const flow = getFlow();
        if (flow === FLOW.PHARMACIST_FAST_UPDATE_INVENTORY) {
            window.location.href = '/back-to-normal'
            clearFlowForApp()
        } else {
            history.push('/inventory-dashboard?tab=inventories')
        }
    }

    const handleCancelUpdate = () => {
        history.goBack()
    }

    const handleDeleteProduct = (productId: string) => {
        history.push('/inventory-dashboard?tab=inventories')
    }

    return (
        <>
            {
                productId ?
                    <FormProduct
                        productId={productId}
                        isModal={false}
                        handleCancelUpdate={handleCancelUpdate}
                        handleUpdateSuccess={handleUpdateSuccess}
                        handleDeleteProduct={handleDeleteProduct}
                    >
                    </FormProduct>
                    : <div className='text-center m-4'>Không tìm thấy sản phẩm</div>
            }
        </>
    )
}

const FormProduct: FC<ProductProps> = (props) => {
    const {
        productId,
        isModal,
        handleCancelUpdate,
        handleDeleteProduct,
        handleUpdateSuccess
    } = props
    const isRequiredInputPrice = false
    const { getCurrentDetailPharmacy } = usePharmacy()

    const getCurrentDetailPharmacyAsync = useAsync<PharmacyDetailModel>(getCurrentDetailPharmacy)
    const [pharmacyId, setPharmacyId] = useState(() => {
        const initialPharmacy = getCurrentDetailPharmacyAsync.value?.pharmacy || new PharmacyDetailModel({});
        return initialPharmacy.mId || 'defaultPharmacyId'; 
    });
    const getInventoryInPharmacyAsync = useAsync(getInventoryInPharmacy)
    const getProductStatAsync = useAsync(getProductStats)
    const searchProductAsync = useAsync(searchEsProduct)
    const deleteInventoryAsync = useAsync(deleteInventory)
    const updatePharmacyInventoryAsync = useAsync(updatePharmacyInventory)
    const getProductPriceTrackAsync = useAsync(getProductPriceTrack)
    const getProductDropshippingTrackAsync = useAsync(getProductDropshipingTrack)
    const getProductDropshippingTrackByAdminAsync = useAsync(getProductDropshipingTrackByAdmin)
    const createProductPriceTrackAsync = useAsync(createProductPriceTrack)
    const createProductDropshippingTrackAsync = useAsync(createProductDropshippingTrack)
    const updateProductDropshippingTrackAsync = useAsync(updateProductDropshippingTrack)
    const updateProductDropshippingTrackByAdminAsync = useAsync(updateProductDropshippingTrackByAdmin)
    const createProductDropshippingTrackByAdminAsync = useAsync(createProductDropshippingTrackByAdmin)
    const getDropshippingPharmacyAsync = useAsync(getDropshippingPharmacy)
    const getDropshippingPharmacyByAdminAsync = useAsync(getDropshippingPharmacyByAdmin)


    let [updatedInvItems, setUpdatedInvItems] = useState<any[]>([])
    let [listPharmacy, setListPharmacy] = useState<any[]>([])
    let [listDropshippingPharmacy, setListDropshippingPharmacy] = useState<any[]>([])
    let [listDropshippingPharmacySelected, setListDropshippingPharmacySelected] = useState<number[]>([])
    let [isAddToCheapestPriceProduct, setIsAddToCheapestPriceProduct] = useState<boolean>(false)
    let [isAddToDropshippingProduct, setIsAddToDropshippingProduct] = useState<boolean>(false)
    let [isCheapestPriceProduct, setIsCheapestPriceProduct] = useState<boolean>(false)
    let [isDropshippingProduct, setIsDropshippingProduct] = useState<boolean>(false)
    let [showListDropshippingPharmacy, setShowListDropshippingPharmacy] = useState<boolean>(false)
    let [isRetailInvoice, setIsRetailInvoice] = useState<boolean>(false)
    let [selectedDistributor, setSelectedDistributor] = useState<string>("")
    let [distributorList, setDistributorList] = useState<ProductDistributor[]>([])

    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType == "ADMIN") return accountInfo.doctor.mId
    }, [accountInfo])

    const [state, setState] = useState({
        visible: false,
        visibleDelete: false,
        inStock: true,
        form: [] as IDongGoi[],
        error: [] as {
            mPrice?: string | null,
            mOriginalPrice?: string | null,
        }[]
    })
    const [productStats, setProductStats] = useState<ProductStat[]>()
    const [showHistory, setShowHistory] = useState(false)
    const [allHaveLevel, setAllHaveLevel] = useState(false)

    let formValuesRef: any = useRef({
        formValues: []
    } as { formValues: Array<IFormValue> })

    useEffect(() => {
        const pharmacyInfo = getPharmacyInfoLocal()
        if (pharmacyInfo) {
            getCurrentDetailPharmacyAsync.execute().then(res =>
                setPharmacyId(res.pharmacy?.mId)
            )
        } else {
            console.error("Not found pharmacy info");
        }
    }, [pharmacyId])

    // Fetch product distributors
    useEffect(() => {
        distributorApi.getProductDistributors()
            .then(res => {
                setDistributorList(res || [])
            })
            .catch(err => {
                console.error("Failed to fetch distributors:", err)
            })
    }, [])

    useEffect(() => {
        searchProductAsync.execute(getQuery(productId))
        getListDropshippingPharmacies()
        if (isAdmin()) {
            getListDropshippingPharmacies()
            checkProductDropshippingTrackByAdmin(pharmacyId, productId)
        } else {
            checkProductPriceTrack(productId)
            checkProductDropshippingTrack(productId)
        }
    }, [pharmacyId, productId])

    const getListDropshippingPharmacies = () => {
        if (isAdmin()) {
            getDropshippingPharmacyByAdminAsync.execute().then(res => {
                if (res.data) {
                    setListPharmacy(res.data)
                }
            })
        } else {
            getDropshippingPharmacyAsync.execute().then(res => {
                if (res.data) {
                    setListPharmacy(res.data)
                }
            })
        }
    }

    const checkProductPriceTrack = (productId: string) => {
        getProductPriceTrackAsync.execute(productId).then(res => {
            if (res.data) {
                setIsAddToCheapestPriceProduct(true)
                setIsCheapestPriceProduct(true)
            }
        })
    }

    const checkProductDropshippingTrackByAdmin = (pharmacyId:string, productId: string) => {
        getProductDropshippingTrackByAdminAsync.execute(pharmacyId, productId).then(res => {
            if (res.data) {
                setIsAddToDropshippingProduct(true)
                setIsDropshippingProduct(true)
                let dropshippingPhars = res.data.dropshippingPhars; // Sửa đúng tên biến
                setListDropshippingPharmacy(dropshippingPhars);
                setListDropshippingPharmacySelected(dropshippingPhars.map((pharmacy: any) => pharmacy.mId));
            }
        })
    }

    const checkProductDropshippingTrack = (productId: string) => {
        getProductDropshippingTrackAsync.execute(productId).then(res => {
            if (res.data) {
                setIsAddToDropshippingProduct(true)
                setIsDropshippingProduct(true)
                setListDropshippingPharmacy(res.data.dropshippingPhars)
                setListDropshippingPharmacySelected(listDropshippingPharmacy.map(pharmacy => pharmacy.mId))
            }
        })
    }

    useEffect(() => {
        const pharmacyId = getCurrentDetailPharmacyAsync.value?.pharmacy?.mId
        const adminId = accountInfo?.loginSession?.mUserId

        if (!pharmacyId) return
        getInventoryInPharmacyAsync.execute({
            adminId,
            pharmacyId,
            filter: {
                where: {
                    mProductId: productId,
                }
            }
        }).then(res => {
            // Check some có true thì true
            const hasAnyInStock = res.listInventory.some((item: any) => item.mInStock === true)
            setState(prev => ({
                ...prev,
                inStock: hasAnyInStock,
            }))
            const firstInventory = new InventoryModel(res.listInventory[0])
            setIsRetailInvoice(firstInventory.mIsRetailInvoice)
            if (firstInventory.mDistributorId) {
                setSelectedDistributor(firstInventory.mDistributorId.toString())
            }
        })
    }, [accountInfo, getCurrentDetailPharmacyAsync.value])

    useEffect(() => {
        if (!pharmacyId
            || !getInventoryInPharmacyAsync.value) {
            return
        }

        let listInventory = getInventoryInPharmacyAsync.value.listInventory

        let packageIds: string[] = listInventory.map((item: any) => item.mPackageId)

        getProductStatAsync.execute(pharmacyId, {
            where: {
                and: [
                    {
                        mPackageId: {
                            inq: packageIds
                        }
                    },
                    {
                        mAdministrativeAreaLevel_0: getCurrentDetailPharmacyAsync.value.pharmacyAddress.mAdministrativeAreaLevel0
                    }
                ]
            }
        }, adminId)
            .then(
                data => {
                    for (let p of listInventory) {
                        let found = data.find(item => item.mPackageId == p.mPackageId)

                        if (found) {
                            p.productStat = found

                            // in case cronjob not update realtime
                            if (p.mPrice < found.mMinPrice) {
                                found.mMinPrice = p.mPrice
                            }
                        }
                    }

                    setProductStats(data)
                }
            )
    }, [getInventoryInPharmacyAsync.value])

    const getQuery = (productId: string) => {
        return {
            _source: ["name", "imageUrls", "pageUrl", '_id', 'dong_goi', 'category'],
            query: {
                match: {
                    _id: productId
                },
            }
        }
    }

    const product: ProductModel = useMemo(() => {
        const listInventory = getInventoryInPharmacyAsync.value?.listInventory || []

        const _product: ProductModel = searchProductAsync.value?.data[0]

        if (!_product || !listInventory) return new ProductModel({})

        const getInventoryById = (id: string) => {
            return listInventory.filter((inventory: InventoryModelWithProductStat) => inventory.mPackageId === id)[0]
        }

        return {
            ..._product,
            dong_goi: _product.dong_goi.map((dong_goi: IDongGoi) => {
                const inventory = new InventoryModelWithProductStat(getInventoryById(dong_goi?.id))

                return {
                    ...dong_goi,
                    inventory
                }
            })
        }
    }, [searchProductAsync.value, productStats])

    useEffect(() => {
        if (!product._id) return
        // Sort: nếu có level thì sort theo level tăng dần, nếu không thì sort theo duoc_ban_le
        const hasAllLevel = product.dong_goi.every(d => d.level !== undefined)
        setAllHaveLevel(hasAllLevel)
        if (hasAllLevel) {
            product.dong_goi.sort((a, b) => (a.level ?? 999) - (b.level ?? 999))
        } else {
            product.dong_goi.sort((a, b) => a.duoc_ban_le > b.duoc_ban_le ? -1 : 1)
        }
        setState(prev => ({
            ...prev,
            form: filterUnUseFullPackage(product.dong_goi),
            error: filterUnUseFullPackage(product.dong_goi)
                .map(donggoi => ({
                    mPrice: !donggoi.inventory?.mPrice ? null : ''
                }))
        }))
    }, [product])

    const getLastestModified = (_product: ProductModel) => {
        let lastestDate = ''
        let lastestModifiedByName = ''

        _product.dong_goi.forEach(donggoi => {
            const modified = donggoi.inventory?.mEsModified || ''

            if (!lastestDate || new Date(modified).getTime() > new Date(lastestDate).getTime()) {
                lastestDate = modified
                lastestModifiedByName = donggoi.inventory?.mLastUpdateByName || ''
            }
        })

        const day = new Date(lastestDate).getDate()
        const month = new Date(lastestDate).getMonth() + 1
        const year = new Date(lastestDate).getFullYear()
        const hours = new Date(lastestDate).getHours()
        const minutes = new Date(lastestDate).getMinutes()

        if (!lastestDate) return

        return [`${day}/${month}/${year}, ${hours}:${minutes}`, lastestModifiedByName]
    }

    const selectedPharmacyNames = listPharmacy
        .filter(pharmacy => listDropshippingPharmacySelected.includes(pharmacy.mId))
        .map(pharmacy => pharmacy.mName)
        .join(', ') || "Chọn nhà thuốc";

    const handleSubmit = () => {
        const error = getError()

        const isValidAll = error.every((value) => {
            return !value.mPrice && !value.mOriginalPrice
        })

        setState(prev => ({ ...prev, error }))
        if (!isValidAll) return

        // Kiểm tra xem có giá nào được nhập không
        const hasAnyPrice = state.form.some(item => item.inventory?.mPrice && item.inventory.mPrice > 0)
        // Nếu tất cả có level và không nhập giá nào thì tự động chuyển sang hết hàng
        const finalInStock = (allHaveLevel && !hasAnyPrice) ? false : state.inStock

        let listInventory: any[] = []
        
        // Nếu tất cả có level và không nhập giá nào -> gửi tất cả với mInStock: false
        if (allHaveLevel && !hasAnyPrice) {
            listInventory = state.form.map((value: IDongGoi) => {
                const inventory: any = {
                    mPharmacyId: pharmacyId,
                    mProductId: productId,
                    mProductName: product.name,
                    mPrice: value.inventory?.mPrice || 0,
                    mOriginalPrice: value.inventory?.mOriginalPrice || 0,
                    mInStock: false,
                    mPackageId: value.id,
                    mPkgName: value.loai_dong_goi?.name,
                    mStatus: 'ACTIVE',
                    mCategory: product.category,
                    mProductStatus: 'ACTIVE',
                    mIsRetailInvoice: isRetailInvoice,
                    mDistributorId: selectedDistributor ? parseInt(selectedDistributor) : null,
                }

                if (value?.inventory?.mId) {
                    inventory.mId = value?.inventory?.mId
                }

                return inventory
            })
        } else {
            listInventory = state.form.map((value: IDongGoi) => {
                const price = value.inventory?.mPrice || 0
                
                // Logic mInStock:
                // - Nếu state.inStock = false (chủ động tắt) -> false hết
                // - Nếu state.inStock = true -> có giá (> 0) thì true, không giá (= 0) thì false
                let itemInStock = false
                if (state.inStock) {
                    itemInStock = price > 0
                }

                const inventory: any = {
                    mPharmacyId: pharmacyId,
                    mProductId: productId,
                    mProductName: product.name,
                    mPrice: price,
                    mOriginalPrice: value.inventory?.mOriginalPrice || 0,
                    mInStock: itemInStock,
                    mPackageId: value.id,
                    mPkgName: value.loai_dong_goi?.name,
                    mStatus: 'ACTIVE',
                    mCategory: product.category,
                    mProductStatus: 'ACTIVE',
                    mIsRetailInvoice: isRetailInvoice,
                    mDistributorId: selectedDistributor ? parseInt(selectedDistributor) : null,
                }

                if (value?.inventory?.mId) {
                    inventory.mId = value?.inventory?.mId
                }

                return inventory
            })
        }

        updatePharmacyInventoryAsync.execute({
            pharmacyId,
            adminId: adminId,
            listInventory
        })
            .then(res => {
                setUpdatedInvItems(listInventory)

                if (isModal) {
                    handleUpdateSuccess(listInventory)
                } else {
                    setState(prev => ({ ...prev, visible: true }))
                }
            })
            .catch(error => {
                console.error("Update inv items error: ", error);
            })

        if (!isCheapestPriceProduct && isAddToCheapestPriceProduct) {
            createProductPriceTrackAsync.execute(productId)
        }
        else if (isCheapestPriceProduct && !isAddToCheapestPriceProduct) {
            createProductPriceTrackAsync.execute(productId)
        }

        if (!isAdmin()) {
            if (!isDropshippingProduct && isAddToDropshippingProduct) {
                createProductDropshippingTrackAsync.execute(productId, listDropshippingPharmacySelected)
            }
            else if (isDropshippingProduct && !isAddToDropshippingProduct) {
                createProductDropshippingTrackAsync.execute(productId)
            } else if (isDropshippingProduct && isAddToDropshippingProduct) {
                updateProductDropshippingTrackAsync.execute(productId, listDropshippingPharmacySelected)
            }
        } else {
            if (!isDropshippingProduct && isAddToDropshippingProduct) {
                createProductDropshippingTrackByAdminAsync.execute(pharmacyId, productId, listDropshippingPharmacySelected)
            }
            else if (isDropshippingProduct && !isAddToDropshippingProduct) {
                createProductDropshippingTrackByAdminAsync.execute(pharmacyId, productId)
            } else if (isDropshippingProduct && isAddToDropshippingProduct) {
                updateProductDropshippingTrackByAdminAsync.execute(pharmacyId, productId, listDropshippingPharmacySelected)
            }
        }
    }

    const handleSelectPharmacy = (mId: number) => {
        setListDropshippingPharmacySelected(prev => {
            if (prev.includes(mId)) {
                return prev.filter(id => id !== mId);
            } else {
                return [...prev, mId];
            }
        });
    };

    const handleCancelSelectPharmacy = () => {
        setListDropshippingPharmacySelected(listDropshippingPharmacy.map(pharmacy => pharmacy.mId))
        setShowListDropshippingPharmacy(false);
    };

    const handleDeleteAllSelectPharmacy = () => {
        setListDropshippingPharmacySelected([]);
    };

    const handleClose = () => {
        setState((prev: any) => ({ ...prev, visible: false }))
        getInventoryInPharmacyAsync.execute({
            adminId,
            pharmacyId,
            filter: {
                where: {
                    mProductId: productId,
                }
            }
        })
    }

    const handleDeleteInventory = () => {
        setState(prev => ({ ...prev, visibleDelete: true }))
    }

    const getError = () => {
        let error = [...state.error]
        
        // Sort tất cả items có level
        const allWithLevel = [...state.form]
            .filter(d => d.level !== undefined)
            .sort((a, b) => a.level - b.level)
        
        // Sort các items có level VÀ có giá (để so sánh giá giữa các cấp)
        const sortedByLevelWithPrice = allWithLevel.filter(d => d.inventory?.mPrice)
        
        // Cấp nhỏ nhất là item đầu tiên sau khi sort
        const minLevelItem = allHaveLevel ? allWithLevel[0] : undefined
        
        state.form.forEach((donggoi, index) => {
            // Nếu có level, là sản phẩm Xuất hóa đơn bán lẻ, và là cấp nhỏ nhất -> bắt buộc nhập giá
            if (allHaveLevel && isRetailInvoice && donggoi.id === minLevelItem?.id && !donggoi.inventory?.mPrice) {
                error[index].mPrice = "Sản phẩm Xuất hóa đơn bán lẻ cần nhập giá cho cấp nhỏ nhất"
            }
            // Nếu tất cả có level thì không bắt buộc nhập giá (trừ trường hợp trên)
            else if (!donggoi.inventory?.mPrice && donggoi.duoc_ban_le && isRequiredInputPrice) {
                error[index].mPrice = "Vui lòng nhập giá sản phẩm"
            }
            else if (donggoi.inventory?.mPrice && donggoi.inventory?.mPrice < 0) {
                error[index].mPrice = "Giá sản phẩm không được nhỏ hơn 0"
            }
            // Validate: giá của level sau phải lớn hơn level trước
            else if (donggoi.level !== undefined && donggoi.inventory?.mPrice) {
                const currentLevelIndex = sortedByLevelWithPrice.findIndex(d => d.id === donggoi.id)
                if (currentLevelIndex > 0) {
                    const prevLevelItem = sortedByLevelWithPrice[currentLevelIndex - 1]
                    if (prevLevelItem.inventory?.mPrice && donggoi.inventory.mPrice <= prevLevelItem.inventory.mPrice) {
                        error[index].mPrice = `Giá cấp ${donggoi.level} phải lớn hơn giá cấp ${prevLevelItem.level}`
                    } else {
                        error[index].mPrice = ""
                    }
                } else {
                    error[index].mPrice = ""
                }
            }
            else {
                error[index].mPrice = ""
            }

            if (
                donggoi.inventory?.mOriginalPrice &&
                donggoi.inventory?.mOriginalPrice <= donggoi.inventory?.mPrice
            ) {
                error[index].mOriginalPrice = "Giá gốc không được nhỏ hơn hoặc bằng đơn giá"
            } else {
                error[index].mOriginalPrice = ""
            }
        })

        return error
    }

    const getViewDongGoi = (packageData: IDongGoi) => {
        if (packageData.loai_dong_goi.name == packageData.don_vi.name) {
            return `${packageData.so_luong} ${packageData.don_vi.name}`
        }
        return `${packageData.loai_dong_goi.name} ${packageData.so_luong} ${packageData.don_vi.name}`
    }

    const filterUnUseFullPackage = (dong_goi: IDongGoi[]) => {
        // Nếu là Kho Trung Tâm -> return tất cả packages
        if (getCurrentDetailPharmacyAsync.value?.pharmacy?.mIsCentralWarehouse) {
            console.log("This is central warehouse, return all packages")
            return dong_goi
        }
        console.log("This is normal pharmacy, filter packages")

        // Logic cũ cho các pharmacy thường
        let useFullPackage: IDongGoi[] = []

        dong_goi.forEach(x => {
            // Nếu có level thì giữ lại tất cả
            if (x.level !== undefined) {
                useFullPackage.push(x)
                return
            }

            if (x.duoc_ban_le) {
                useFullPackage.push(x)
                return
            }

            const parentPackage = dong_goi.find(y => y.don_vi.id == x.loai_dong_goi.id)
            if (!parentPackage) {
                // it means this is biggest package
                useFullPackage.push(x)
            } else {
                if (parentPackage.so_luong != 1) {
                    useFullPackage.push(x)
                }
            }
        })

        return useFullPackage
    }

    return <RollbarErrorBoundary>
        <div className='w-100'>
            {
                isModal ?
                    <></> :
                    <Header
                        title="Cập nhật sản phẩm"
                        subTitle={getCurrentDetailPharmacyAsync.value?.pharmacy?.mName}
                    />
            }

            <div id="main">
                {
                    (getInventoryInPharmacyAsync.status == "loading" || getCurrentDetailPharmacyAsync.status == "loading" || searchProductAsync.status == "loading") ?
                        <div className="wrap-loading">
                            <Loading />
                        </div> :
                        <div className="container">
                            {(showHistory && isAdmin())? 
                            <ProductHistory
                                onGoBack={() => setShowHistory(false)}
                                productId={productId}
                                pharmacyId={pharmacyId}
                                adminId={adminId? adminId : ""}
                            /> :
                            <>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center mr-3 mb-2 mt-2">
                                    <div className="d-flex align-item-center" style={{ border: 'solid #e5e5e5 1px' }}>
                                        <img style={{ objectFit: 'contain', width: '80px', maxHeight: '100px' }} src={product.imageUrls[0] ? product.imageUrls[0] : './images/default-medicine.png'} />
                                    </div>
                                    <div className='ml-1'>
                                        <strong>{product.name}</strong>
                                        {
                                            state.form.length > 0
                                                && state.form[0].inventory?.productStat ? (
                                                <div className='mt-1'>
                                                    Giá thấp nhất khu vực
                                                    {
                                                        state.form.map((dong_goi: IDongGoi, index) => {
                                                            return <span key={index} className="ml-2 txt-orange font-weight-bold">{(dong_goi.inventory?.productStat?.mMinPrice) ? `${formatPrice(dong_goi.inventory?.productStat?.mMinPrice)} đ/${dong_goi.loai_dong_goi.name}` : null}</span>
                                                        })
                                                    }
                                                </div>
                                            ) : null
                                        }

                                    </div>

                                </div>
                                <b
                                    style={{ color: '#36cd7a', cursor: 'pointer' }}
                                    onClick={handleDeleteInventory}>Xoá</b>
                            </div>
                            {!isAdmin() && <div className='mb-2 d-flex'>
                                {isAddToCheapestPriceProduct ?
                                    <img src="./images/green-checkbox-icon.jpg" alt="gci" width={20} height={20}
                                        onClick={() => {
                                            setIsAddToCheapestPriceProduct(!isAddToCheapestPriceProduct)
                                        }} /> :
                                    <img src="./images/square-icon-png.jpg" alt="sqi" width={20} height={20}
                                        onClick={() => {
                                            setIsAddToCheapestPriceProduct(!isAddToCheapestPriceProduct)
                                        }} />}
                                <span className='ml-2' onClick={() => {
                                    setIsAddToCheapestPriceProduct(!isAddToCheapestPriceProduct)
                                }} >Thêm vào danh sách theo dõi giá thấp nhất</span>
                            </div>}
                            {getCurrentDetailPharmacyAsync.value?.pharmacy?.mType === 'DEFAULT_PHARMACY' && 
                            <div>
                                <div className='mb-2 d-flex'>
                                    {isAddToDropshippingProduct ?
                                        <img src="./images/green-checkbox-icon.jpg" alt="gci" width={20} height={20}
                                            onClick={() => {
                                                setIsAddToDropshippingProduct(!isAddToDropshippingProduct)
                                            }} /> :
                                        <img src="./images/square-icon-png.jpg" alt="sqi" width={20} height={20}
                                            onClick={() => {
                                                setIsAddToDropshippingProduct(!isAddToDropshippingProduct)
                                            }} />}
                                    <span className='ml-2' onClick={() => {
                                        setIsAddToDropshippingProduct(!isAddToDropshippingProduct)
                                    }} >Sản phẩm chạy hàng</span>
                                </div>
                                { isAddToDropshippingProduct && <div>
                                    <Form.Group className="justify-content-between align-items-center">
                                        <Form.Label style={{
                                            fontWeight: 500,
                                            float: 'left',
                                        }}>Nơi chạy hàng (nếu có)</Form.Label>
                                        <div style={{ width: '100%' }}>
                                            <Form.Control readOnly name='mPharmacyId' as="select" custom onClick={() => setShowListDropshippingPharmacy(true)}>
                                                <option>{selectedPharmacyNames}</option>
                                            </Form.Control>
                                        </div>
                                    </Form.Group>
                                </div>}
                            </div>
                            }
                            {/* Central Warehouse Only: Retail Invoice & Distributor Selection */}
                            {getCurrentDetailPharmacyAsync.value?.pharmacy?.mIsCentralWarehouse && (
                            <>
                                {/* Retail Invoice Section - Admin always sees toggle, User only sees when distributed */}
                                {(isRetailInvoice || isAdmin()) && (
                                <div className="d-flex py-2 justify-content-between align-items-center" style={{ 
                                    backgroundColor: isRetailInvoice ? '#E8F5E9' : '#F5F5F5',
                                    padding: '12px',
                                    borderRadius: '8px',
                                    marginBottom: '12px',
                                    border: isRetailInvoice ? '1px solid #81C784' : '1px solid #E0E0E0'
                                }}>
                                    <div className="d-flex align-items-center">
                                        <span style={{ 
                                            fontSize: '14px', 
                                            fontWeight: 500,
                                            color: isRetailInvoice ? '#2E7D32' : '#757575'
                                        }}>
                                            Xuất hóa đơn bán lẻ
                                        </span>
                                    </div>
                                    {isAdmin() && (
                                        <BootstrapSwitchButton
                                            size='sm'
                                            onChange={(value) => {
                                                setIsRetailInvoice(value)
                                            }}
                                            onlabel=' '
                                            offlabel=' '
                                            checked={isRetailInvoice}
                                            onstyle="success"
                                            offstyle="secondary"
                                        />
                                    )}
                                </div>
                                )}
                                {/* Distributor Selection */}
                                <div className="py-2" style={{ 
                                    backgroundColor: '#F5F5F5',
                                    padding: '12px',
                                    borderRadius: '8px',
                                    marginBottom: '12px',
                                    border: '1px solid #E0E0E0'
                                }}>
                                    <Form.Group className="mb-0">
                                        <Form.Label style={{ 
                                            fontSize: '14px', 
                                            fontWeight: 500,
                                            color: '#757575',
                                            marginBottom: '8px'
                                        }}>
                                            Nhà phân phối
                                        </Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            value={selectedDistributor}
                                            onChange={(e) => setSelectedDistributor(e.target.value)}
                                            style={{
                                                fontSize: '14px',
                                                borderColor: '#E0E0E0'
                                            }}
                                        >
                                            <option value="">-- Chọn nhà phân phối --</option>
                                            {distributorList.map(distributor => (
                                                <option key={distributor.mId} value={distributor.mId}>
                                                    {distributor.mName}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </div>
                            </>
                            )}
                            {
                                isModal ?
                                    <></>
                                    : <div className="row">
                                        <div className="spacing" />
                                    </div>
                            }
                            <div className="d-flex py-2 custom-switch justify-content-between">
                                <div className='d-flex justify-content-between' style={{ flexDirection: 'column' }}>
                                    <div className='mb-3 text-left'>Trạng thái sản phẩm</div>
                                    {
                                        getLastestModified(product) &&
                                        <div style={{ color: 'gray', textAlign: 'left' }}>Cập nhật lần cuối {getLastestModified(product)![0]}</div>
                                    }
                                    {
                                        getLastestModified(product) && getLastestModified(product)![1] &&
                                        <div style={{ color: 'gray', textAlign: 'left' }}>Bởi {getLastestModified(product)![1]}</div>
                                    }
                                    {isAdmin() &&
                                        <div 
                                            className='mb-3 text-left'
                                            style={{ color: 'blue', cursor: 'pointer' }}
                                            onClick={() => {
                                                setShowHistory(true)
                                            }}
                                        >
                                            Xem lịch sử chỉnh sửa
                                        </div>
                                    }
                                </div>
                                <div className='d-flex justify-content-center' style={{ flexDirection: 'column', alignItems: 'flex-end', color: 'gray', whiteSpace: 'nowrap' }}>
                                    <BootstrapSwitchButton
                                        size='sm'
                                        onChange={(value) => {
                                            setState(prev => ({ ...prev, inStock: value }))
                                        }}
                                        onlabel=' '
                                        offlabel=' '
                                        checked={state.inStock}
                                        onstyle="success"
                                        offstyle="dark"
                                    />
                                    <div className='mt-3'>{state.inStock ? 'Còn hàng' : 'Hết hàng'}</div>
                                </div>
                            </div>
                            <div className="product-info">
                                {(() => {
                                    // Tính minLevelId cho việc hiển thị dấu *
                                    const minLevelId = allHaveLevel 
                                        ? [...state.form].sort((a, b) => (a.level ?? 999) - (b.level ?? 999))[0]?.id 
                                        : undefined
                                    
                                    return state.form.map((dong_goi: IDongGoi, index) => {
                                        const borderBottom = index + 1 != state.form?.length ? '1px solid #e2e2e2' : 'unset'
                                        const isMinLevelRequired = allHaveLevel && isRetailInvoice && dong_goi.id === minLevelId
                                        // if (!dong_goi.duoc_ban_le) return

                                        return <div className='mb-3' style={{ borderBottom }} key={index}>
                                            <Form.Group className="d-flex justify-content-between align-items-center" style={{ marginBottom: '8px' }}>
                                                <Form.Label>
                                                    Đơn vị
                                                    {dong_goi.level !== undefined && (
                                                        <span 
                                                            style={{
                                                                backgroundColor: dong_goi.level === 1 ? '#28a745' : dong_goi.level === 2 ? '#17a2b8' : '#6c757d',
                                                                color: 'white',
                                                                padding: '2px 6px',
                                                                borderRadius: '8px',
                                                                fontSize: '10px',
                                                                fontWeight: 600,
                                                                marginLeft: '6px'
                                                            }}
                                                        >
                                                            Cấp {dong_goi.level}
                                                        </span>
                                                    )}
                                                </Form.Label>
                                                <div style={{ width: '50%' }}>
                                                    <Form.Control readOnly name='mPackageId' as="select" custom>
                                                        <option>{getViewDongGoi(dong_goi)}</option>
                                                    </Form.Control>
                                                </div>
                                            </Form.Group>
                                            <Form.Group className="d-flex justify-content-between align-items-center" style={{ marginBottom: '8px' }}>
                                                <Form.Label>
                                                    <div className="d-flex">
                                                        Đơn giá (VND) {(isRequiredInputPrice || isMinLevelRequired) && <div className='ml-2' style={{ color: 'red', fontSize: 20 }}>*</div>}
                                                    </div>
                                                </Form.Label>
                                                <div style={{ width: '50%' }}>
                                                    <CurrencyInput
                                                        id="input-example"
                                                        name="input-name"
                                                        groupSeparator="."
                                                        decimalSeparator=","
                                                        style={{
                                                            width: '100%',
                                                            border: '1px solid #ced4da',
                                                            borderRadius: '.25rem',
                                                            padding: '0.575rem 0.75rem',
                                                            borderColor: (state.error[index].mPrice == "missValue" || state.error[index].mPrice == "negativeValue") ? 'red' : '#ced4da'
                                                        }}
                                                        decimalsLimit={2}
                                                        value={dong_goi.inventory?.mPrice == 0 ? '' : dong_goi.inventory?.mPrice}
                                                        onValueChange={(value, name) => {
                                                            let newForm = [...state.form]

                                                            if (!newForm[index].inventory) return


                                                            (newForm[index].inventory as InventoryModel).mPrice = +(value || 0)


                                                            const error = getError()
                                                            setState(prev => ({ ...prev, form: newForm, error }))
                                                        }}
                                                    />
                                                    {
                                                        !!state.error[index].mPrice &&
                                                        <span style={{ color: 'red' }}>{state.error[index].mPrice}</span>
                                                    }
                                                </div>
                                            </Form.Group>
                                            {
                                                product.category != "c_med_otc" && product.category != "c_med_rx" &&
                                                <Form.Group className="d-flex justify-content-between align-items-center" style={{ marginBottom: '8px' }}>
                                                    <Form.Label>
                                                        <div className="d-flex" style={{ textAlign: "start" }}>
                                                            Giá gốc <br /> (Trước khuyến mãi)
                                                        </div>
                                                    </Form.Label>
                                                    <div style={{ width: '50%' }}>
                                                        <CurrencyInput
                                                            id="input-example"
                                                            name="input-name"
                                                            groupSeparator="."
                                                            decimalSeparator=","
                                                            style={{
                                                                width: '100%',
                                                                border: '1px solid #ced4da',
                                                                borderRadius: '.25rem',
                                                                padding: '0.575rem 0.75rem',
                                                                borderColor: !!state.error[index].mOriginalPrice ? 'red' : '#ced4da'
                                                            }}
                                                            decimalsLimit={2}
                                                            value={dong_goi.inventory?.mOriginalPrice == 0 ? '' : dong_goi.inventory?.mOriginalPrice}
                                                            onValueChange={(value, name) => {
                                                                let newForm = [...state.form]
                                                                // let error = [...state.error]

                                                                if (!newForm[index].inventory) return

                                                                (newForm[index].inventory as InventoryModel).mOriginalPrice = +(value || 0)
                                                                // if (error[index] && dong_goi.duoc_ban_le) {
                                                                //     error[index].mOriginalPrice = !value ? 'error' : ''
                                                                // }

                                                                const error = getError()
                                                                setState(prev => ({ ...prev, form: newForm, error }))
                                                            }}
                                                        />
                                                        {
                                                            !!state.error[index].mOriginalPrice &&
                                                            <span style={{ color: 'red' }}>{state.error[index].mOriginalPrice}</span>
                                                        }
                                                    </div>
                                                </Form.Group>
                                            }
                                        </div>
                                    })
                                })()}
                                <div className="fixed-button d-flex justify-content-between">
                                    <button type="button" className="btn btn-white mr-3" data-dismiss="modal" onClick={handleCancelUpdate}>Hủy</button>
                                    <Button
                                        type="submit"
                                        loading={updatePharmacyInventoryAsync.status === "loading"}
                                        className="btn btn-orange"
                                        onClick={handleSubmit}
                                        text="Hoàn thành"
                                    />
                                </div>
                            </div>
                            </>}
                        </div>
                }
            </div >
            <Modal show={state.visible} onHide={handleClose}>
                <div className="modal-dialog m-0" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <img src="./images/check.svg" alt="cancel" className="img-fluid" width={48} />
                        </div>
                        <div className="modal-body">
                            <h4>Cập nhật thành công!</h4>
                        </div>
                        <div className="modal-footer">
                            <button className="btn" onClick={() => {
                                setState((prev: any) => ({ ...prev, visible: false }))
                                handleUpdateSuccess(updatedInvItems)
                            }}>OK</button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal show={state.visibleDelete} onHide={() => setState((prev: any) => ({ ...prev, visibleDelete: false }))}>
                <div className="modal-dialog m-0" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <img src="./images/delete_icon.png" alt="cancel" className="img-fluid" width={48} />
                        </div>
                        <div className="modal-body">
                            <h4>Bạn muốn xóa sản phẩm này ra khỏi kho hàng?</h4>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn"
                                onClick={async () => {
                                    await deleteInventoryAsync.execute({
                                        adminId, pharmacyId, productId
                                    })
                                    setState((prev: any) => ({ ...prev, visibleDelete: false }))
                                    handleDeleteProduct(productId)
                                }}
                            >OK</button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal backdrop={true} show={showListDropshippingPharmacy} onHide={() => setShowListDropshippingPharmacy(false)} dialogClassName='mt-5'>
                <div className="modal-dialog m-0" role="document">
                    <div className="modal-content" style={{
                        border: 'none'
                    }}>
                    <div style={{
                        display: 'flex',
                        boxShadow: '0px 1px 0px 0px #0000000D',
                        padding: 15,
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <strong style={{
                            fontSize: 16
                        }}>Danh sách nơi chạy hàng</strong>
                        <span style={{
                            color: '#FA1E1A'
                        }}
                        onClick={handleDeleteAllSelectPharmacy}>Bỏ chọn tất cả</span>
                    </div>
                    <div className="modal-body" style={{
                        overflowY: 'scroll',
                        textAlign: 'left',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 12,
                        maxHeight: 400,
                        marginBottom: 65
                    }}>
                        {listPharmacy.map(pharmacy => (
                        <div key={pharmacy.mId} className="d-flex align-items-center"
                        >
                            <div 
                                onClick={() => handleSelectPharmacy(pharmacy.mId)} 
                                style={{ cursor: 'pointer' }}
                            >
                                <img 
                                    src={listDropshippingPharmacySelected.includes(pharmacy.mId) 
                                        ? "./images/green-checkbox-icon.jpg" 
                                        : "./images/square-icon-png.jpg"} 
                                    alt={listDropshippingPharmacySelected.includes(pharmacy.mId) ? "gci" : "sqi"} 
                                    width={20} 
                                    height={20} 
                                />
                                <span 
                                    className="ml-2" 
                                    style={listDropshippingPharmacySelected.includes(pharmacy.mId) ? { color: '#26CD7A' } : {}}
                                >
                                    {pharmacy.mName}
                                </span>
                            </div>
                        </div>
                    ))}
                        <div className="fixed-button d-flex justify-content-between">
                            <button type="button" className="btn btn-white mr-3" data-dismiss="modal" onClick={handleCancelSelectPharmacy}>Hủy</button>
                            <Button
                                type="submit"
                                loading={updatePharmacyInventoryAsync.status === "loading"}
                                className="btn btn-orange"
                                onClick={() => setShowListDropshippingPharmacy(false)}
                                text="Xác nhận"
                            />
                        </div>
                    </div>
                    </div>
                </div>
            </Modal>
        </div >
    </RollbarErrorBoundary >
}

export default FormProduct